<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Announcements</h2>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-link :to="{ name:'NotificationsAdd' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i> Add
          Announcement
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th>Extension</th>
            <th class="d-none d-md-table-cell">Zone</th>
            <th class="d-none d-md-table-cell">Sound/Playlist</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="notification in filtered_notifications" :key="notification.notification_id">
            <td>{{ notification.name }}</td>
            <td>
              <span v-if="notification.extension !== 0">{{ notification.extension }}</span>
              <span v-else>N/A</span>
            </td>
            <td class="d-none d-md-table-cell">{{ notification.zone.name }}</td>
            <td class="d-none d-md-table-cell" v-if="notification.sound_type_id === 1">{{ notification.sound.filename }}</td>
            <td class="d-none d-md-table-cell" v-else-if="[2,3,4].includes(notification.sound_type_id)">{{ notification.playlist.name }}</td>
            <td>
              <div class="dropdown">
                <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <router-link
                    :to="{ name:'NotificationsEdit', params: { notification_id: notification.notification_id } }"
                    class="dropdown-item"><i class="fa fa-pencil-alt fa-fw"
                                                                                            aria-hidden="true"></i>&nbsp;Edit
                  </router-link>
                  <a class="dropdown-item" href="#" onclick="return false" @click="deleteNotification(notification)"><i
                    class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete</a>
                  <div class="dropdown-divider" v-if="[2,3,4].includes(logged_in_user.group_id)"></div>
                  <a class="dropdown-item" @click="playNotification(notification)"><i
                    class="fa fa-play fa-fw" aria-hidden="true"></i> Play</a>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'notifications',
  computed: {
    ...mapGetters({
      notifications: 'allNotifications',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_notifications: function () {
      return this.notifications.filter(notification => notification.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getNotifications')
  },
  methods: {
    ...mapActions([
      'deleteNotification',
      'playNotification'
    ]),
    stopNotifications () {
      this.$store.dispatch('executeCommand', '6')
    }
  }
}
</script>

<style scoped>

</style>
